export default __webpack_public_path__ + "static/media/chess-wood-pieces.c5630291.webp";